import { Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { getBarToneBackground } from '@shared/components/slot-bar/slot-bar.util';
import { IStackedBarSegment } from './stacked-bar.interface';

/** Continuous bar split into proportional segments; whatever the segments leave of `total` stays grey. */
@Component({
  imports: [MatTooltipModule],
  selector: 'app-stacked-bar',
  templateUrl: './stacked-bar.component.html',
})
export class StackedBarComponent {
  public readonly segments = input.required<IStackedBarSegment[]>();
  public readonly total = input.required<number>();
  /** Px width, e.g. to match the slot bars above it; 0 = fill the row. */
  public readonly width = input<number>(0);

  public readonly visibleSegments = computed(() => {
    const total = this.total();

    return total > 0
      ? this.segments()
          .filter((segment) => segment.value > 0)
          .map((segment) => ({ ...segment, percent: (Math.min(segment.value, total) / total) * 100 }))
      : [];
  });

  public readonly getBarToneBackground = getBarToneBackground;
}
